import FormSection from '@/components/Forms/FormSection';
import { CheckboxInput } from '@palmetto/palmetto-components';

type AttestationSectionProps = {
  projectAttestLabel: string;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  values: any;
  isSubmitting: boolean;
  touched: any;
  errors: any;
  isPackageEditable?: boolean;
};

export const AttestationSection = ({
  projectAttestLabel,
  setFieldValue,
  values,
  isSubmitting,
  touched,
  errors,
  isPackageEditable = true,
}: AttestationSectionProps) => {
  return (
    <FormSection title="Project Attestation">
      <CheckboxInput
        id="projectAttestationCheckbox"
        name="projectAttestationCheckbox"
        label={projectAttestLabel}
        onChange={(event) => setFieldValue('projectAttestationCheckbox', event.target.checked)}
        isChecked={Boolean(values.projectAttestationCheckbox)}
        isDisabled={isSubmitting || !isPackageEditable}
        error={touched.projectAttestationCheckbox && (errors.projectAttestationCheckbox as string)}
      />
    </FormSection>
  );
};
